var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelVentParcial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.72 10.44L12.13 4.28001L10.38 3.26001V5.29001V18.16V18.83L10.96 19.16L21.55 25.32L23.3 26.34V24.31V11.45V10.77L22.72 10.44Z",
    fill: "#B8B8B9",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.14 11.45L11.54 5.29001V18.16L22.14 24.31V11.45Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.14 22.62L12.95 17.28V6.10001L11.54 5.29001V16.46V18.16L12.95 18.97L22.14 24.31V22.62Z",
    fill: "#DDDDDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.95 17.28V6.10001L11.54 5.29001V16.46V18.16L12.95 17.28Z",
    fill: "#A6A6A7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.14 11.45L11.54 5.29001V18.16L22.14 24.31V11.45Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.86 15.57L11.54 15.11",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M19.29 13.49L8.70001 7.32999L11.54 18.16L22.14 24.31L19.29 13.49Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.29 13.49L8.70001 7.32999L11.54 18.16L22.14 24.31L19.29 13.49Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.34 21.27L22.14 20.72",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M19.69 19.9L18.92 17",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelVentParcial);
export default __webpack_public_path__ + "static/media/SelVentParcial.8603009303bd9b50a7a1d7dc69c96eac.svg";
export { ForwardRef as ReactComponent };